module.exports = __webpack_public_path__ + "static/img/logo.8dcafa6e.png";